/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_itemSearch">;
    readonly " $refType": "SharedItemTile_itemSearch";
};
export type SharedItemTile_itemSearch$data = SharedItemTile_itemSearch;
export type SharedItemTile_itemSearch$key = {
    readonly " $data"?: SharedItemTile_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedItemTile_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'e2aba102253de5a5283b1fccd21c1433';
export default node;
